/* YARIYARI — interacciones base (sin dependencias) */
(function () {
  'use strict';

  /* ---------- Menú móvil ---------- */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', String(!open));
      burger.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- Reveal en scroll ---------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 5) * 60 + 'ms';
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(title, msg) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.innerHTML = '<strong>' + title + '</strong>' + msg;
    el.setAttribute('data-open', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.setAttribute('data-open', 'false'); }, 3600);
  }

  /* ---------- Contador del carrito ---------- */
  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      });
  }

  /* ---------- Añadir al carrito por AJAX ---------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest('form[data-ajax-cart]');
    if (!form) return;
    ev.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Agregando…'; }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast('Sin stock', res.data.description || 'Esta pieza ya no está disponible.');
          return;
        }
        toast('Añadido al carrito', res.data.product_title || 'Pieza añadida.');
        return refreshCart();
      })
      .catch(function () { toast('Error', 'No se pudo agregar. Intenta de nuevo.'); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
      });
  });

  /* ---------- FAQ ---------- */
  document.addEventListener('click', function (ev) {
    var q = ev.target.closest('.faq__q');
    if (!q) return;
    var item = q.parentElement;
    var open = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', String(!open));
    q.setAttribute('aria-expanded', String(!open));
  });

  /* ---------- Galería de producto ---------- */
  document.addEventListener('click', function (ev) {
    var thumb = ev.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (main) { main.src = thumb.dataset.full || thumb.src; main.srcset = ''; }
  });

  /* ---------- Selector de variante ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    picker.addEventListener('change', function () {
      var form = picker.closest('form');
      var select = picker.querySelector('select');
      if (!form || !select) return;
      var opt = select.options[select.selectedIndex];
      var input = form.querySelector('[name="id"]');
      if (input) input.value = select.value;
      var price = document.querySelector('[data-variant-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        var sold = opt.dataset.available === 'false';
        btn.disabled = sold;
        btn.textContent = sold ? 'Agotada' : 'Agregar al carrito';
      }
    });
  });

  /* ---------- Header compacto al hacer scroll ---------- */
  var header = document.querySelector('.header');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.style.boxShadow = y > 12 ? '0 10px 30px -22px rgba(0,0,0,.9)' : 'none';
      last = y;
    }, { passive: true });
  }

  refreshCart();
})();
